import ApiService from "./api.service";
export default class CalendarService extends ApiService {
    static base_url = `${super.base_url}/calendars`;
}
